import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PaymenredsysRedirctModal from './PaymentRedsysRedirectModal';
import PaymenstripeRedirctModal from './PaymentStripeRedirectModal';
import PaymenpaypalRedirctModal from './PaymentPaypalRedirectModal';
import LogoRedsys from '../assets/images/icon-redsys-48.png';
import LogoPaypal from '../assets/images/icon-paypal-48.png';
import LogoStripe from '../assets/images/icon-stripe-48.png';

function PaymentGatewayModal({ show, onClose, invoice_data }) {
  const { t } = useTranslation();
  const [selectedGateway, setSelectedGateway] = useState(null);
  //Control GWP pago activadas
  const stripeEnabled = parseInt(process.env.REACT_APP_STRIPE_ENABLED) > 0;
  const paypalEnabled = parseInt(process.env.REACT_APP_PAYPAL_ENABLED) > 0;

  const handleBack = () => setSelectedGateway(null);

  const renderGatewayForm = () => {
    switch (selectedGateway) {
      case 'redsys':
        return (
          <PaymenredsysRedirctModal
            showModal={true}
            close={onClose}
            invoice_data={invoice_data}
            embedded={true}
          />
        );
      case 'stripe':
        return (
          <PaymenstripeRedirctModal
            showModal={true}
            close={onClose}
            invoice_data={invoice_data}
            embedded={true}
          />
        );
      case 'paypal':
        return (
          <PaymenpaypalRedirctModal
            showModal={true}
            close={onClose}
            invoice_data={invoice_data}
            embedded={true}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {!selectedGateway ? t('choose-payment-method') : t('confirm-and-pay')}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!selectedGateway ? (
          <div className="text-center">
          <div class="d-flex justify-content-center">
                <Button
                  className="m-2 d-flex flex-column align-items-center"
                  variant="outline-primary"
                  onClick={() => setSelectedGateway('redsys')}
                >
                  <img src={LogoRedsys} alt="Pagar con Redsys" style={{ maxWidth: '30px' }} />
                  <span>{t('pay-redsys')}</span>
                </Button>
                 {paypalEnabled && (
                    <Button
                      className="m-2 d-flex flex-column align-items-center"
                      variant="outline-primary"
                      onClick={() => setSelectedGateway('paypal')}
                    >
                      <img src={LogoPaypal} alt="Pagar con Paypal" style={{ maxWidth: '30px' }} />
                      <span>{t('pay-paypal')}</span>
                    </Button>
                 )}
                 {stripeEnabled && (
                    <Button
                      className="m-2 d-flex flex-column align-items-center"
                      variant="outline-primary"
                      onClick={() => setSelectedGateway('stripe')}
                    >
                      <img src={LogoStripe} alt="Pagar con Stripe" style={{ maxWidth: '30px' }} />
                      <span>{t('pay-stripe')}</span>
                    </Button>
                )}

            </div>
          </div>
        ) : (
          renderGatewayForm()
        )}
      </Modal.Body>

      <Modal.Footer>
        {selectedGateway && (
          <Button variant="secondary" onClick={handleBack}>
            ← {t('back')}
          </Button>
        )}
        <Button variant="danger" onClick={onClose}>
          {t('btn-close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PaymentGatewayModal;
